// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__yl6UW","content":"styles_content__esS95"};